export default __webpack_public_path__ + "static/media/hello-dark.5d44f5f5.png";